<template>
  <div>
    <div class="item-content" style="display: flex; align-items: start;">
      <div
        class="item-inner"
        style="width: 100%; display: flex; align-items: start;">
        <div class="task-expand">
          <f7-link
            @click="task.expanded=!task.expanded"
            v-if="task.childList && task.childList.length > 0">
            <f7-icon
              :icon="task.expanded?'cicon-shujiedian':'cicon-genjiedian'"
              :class="'expand-icon-node'+task.nodeLevel"
              size="1.2rem">
            </f7-icon>
          </f7-link>
          <f7-icon fa="circle" class="expand-icon-node5" size="1.2rem" v-else></f7-icon>
        </div>
        <div style="padding-left: 0.5rem; width: 100%;">
          <div class="task-title">
            <f7-link
              :href="`/project/info/${task.id}?rootId=${rootId}`"
              style="display: flex; align-items: flex-start;">
              <span>{{ task.name }}</span>
              <span style="line-height: 1.4rem;">
                <img
                src="@/assets/img/fuzhu.png"
                class="fuzhu-img"
                v-if="task.type === 'assistProject'" />
              </span>
            </f7-link>
          </div>
          <div class="sub-info">
            <div style="display: flex; align-items: center;">
              <div>
                {{ task.startupTime | formatDateValue }}
                <span style="padding: 0rem; 0.3rem;">至</span>
                {{ task.completedTime | formatDateValue }}
              </div>
              <div>&nbsp;&nbsp;</div>
              <div>
                <div class="project-status-assign" v-if="task.projectStatus === '10'">
                  {{ task.projectStatusDesc }}
                </div>
                <div class="project-status-releasing" v-if="task.projectStatus === '20'">
                  {{ task.projectStatusDesc }}
                </div>
                <div class="project-status-assigned" v-if="task.projectStatus === '30'">
                  {{ task.projectStatusDesc }}
                </div>
                <div class="project-status-working" v-if="task.projectStatus === '40'">
                  {{ task.projectStatusDesc }}
                </div>
                <div class="project-status-checking" v-if="task.projectStatus === '50'">
                  {{ task.projectStatusDesc }}
                </div>
                <div class="project-status-checked" v-if="task.projectStatus === '60'">
                  {{ task.projectStatusDesc }}
                </div>
              </div>
            </div>
            <div>
              {{ task.companyName }}
            </div>
            <div class="project-footer-row">
              <f7-link
                :href="`/project/msgList/${task.id}?title=通知-${task.name}`"
                class="footer-link">
                <f7-icon size="1rem" icon="cicon-tongzhi" class="project-msg-icon">
                  <f7-badge
                    color="red"
                    class="point-badge"
                    style="
                      line-height: 8px;
                      height: 8px;
                      border-radius: 8px;
                      padding: 0 0px;
                      min-width: 8px;
                      font-size: 8px;
                      margin-left: -8px;"
                    v-if="task.unReadMsgNum > 0">
                  </f7-badge>
                </f7-icon>
                &nbsp;{{ task.unReadMsgNum || 0 }}个通知
              </f7-link>
              <div class="line-vertical">&nbsp;</div>
              <f7-link @click="showComment" class="footer-link">
                <f7-icon size="1rem" icon="cicon-xiaoxi" class="icon-comments">
                  <f7-badge
                    color="red"
                    class="point-badge"
                    style="
                      line-height: 8px;
                      height: 8px;
                      border-radius: 8px;
                      padding: 0 0px;
                      min-width: 8px;
                      font-size: 8px;
                      margin-left: -8px;"
                    v-if="getUnreadMsg(task.id) > 0">
                  </f7-badge>
                </f7-icon>
                &nbsp;工作群
              </f7-link>
            </div>
            <div v-if="commentsDisplay" :key="task.id+'comments'">
            <div class="comments-expand-icon">
              <f7-icon icon="cicon-zhankai1" size="0.8rem"></f7-icon>
            </div>
            <f7-swiper
              class="swiper-info"
              :params="{speed: 300, slidesPerView: 2, spaceBetween: 0,
                observer: true, observeParents: true}">
              <f7-swiper-slide v-if="task.parentId">
                <f7-link @click="callGroupChat(task.parentId)">
                  <div class="swiper-slide-info">
                    <f7-icon icon="cicon-qunjiaoliu1" size="2em">
                      <f7-badge color="red" v-if="getUnreadMsg(task.parentId) > 0">
                        {{ getUnreadMsg(task.parentId) }}
                      </f7-badge>
                    </f7-icon>
                    <div>上级工作群</div>
                  </div>
                </f7-link>
              </f7-swiper-slide>
              <f7-swiper-slide v-if="task.id">
                <f7-link @click="callGroupChat(task.id)">
                  <div class="swiper-slide-info">
                    <f7-icon icon="cicon-qunjiaoliu1" size="2em">
                      <f7-badge color="red" v-if="getUnreadMsg(task.id) > 0">
                        {{ getUnreadMsg(task.id) }}
                      </f7-badge>
                    </f7-icon>
                    <div>当前工作群</div>
                  </div>
                </f7-link>
              </f7-swiper-slide>
            </f7-swiper>
          </div>
            <!-- <div v-if="task.workerNum">
              工人数<span class="primary-text">{{ task.workerNum }}</span>
            </div>
            <div class="other-status-info" v-else>
              <div>任务数<span class="primary-text">{{ task.childNum || 0 }}</span></div>
              <div>未分派<span class="primary-text">{{ task.toAssignChildNum || 0 }}</span></div>
              <div>已验收<span class="primary-text">{{ task.checkedChildNum || 0 }}</span></div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="item-after" style="padding-top: 10px;">
        <f7-link
          icon="cicon-chaifengongneng"
          class="more-menu"
          @click="openPopover(task.id, task.name, task.parentId, task.perms, $event)">
        </f7-link>
      </div>
    </div>
    <div v-if="task.expanded && task.childList">
      <li v-for="sub1 in task.childList" :key="sub1.name">
        <ul>
          <hierarchical-task
            :root-id="rootId"
            :task="sub1"
            :task-id.sync="sub1.id">
          </hierarchical-task>
        </ul>
      </li>
    </div>
    <div style="height: 0.01rem; font-size: 0.01rem;">&nbsp;</div>
  </div>
</template>

<script>
import { toGroupConversation, getUnreadMsgCount } from '@/util/native';
import bus from '@/util/bus';
import { dateFormat } from '@/util/dateUtils';
import HierarchicalTask from './HierarchicalTask';

export default {
  name: 'HierarchicalTask',
  props: ['rootId', 'task', 'taskId'],
  components: {
    HierarchicalTask,
  },
  data() {
    return {
      commentsDisplay: false,
    };
  },
  filters: {
    formatDateValue: value => dateFormat(value),
  },
  methods: {
    callGroupChat(id) {
      toGroupConversation(id);
    },
    getUnreadMsg(id) {
      try {
        const param = {};
        this.$set(param, `${id}`, 0);
        const resObj = getUnreadMsgCount(JSON.stringify(param));
        return Number.parseInt(resObj[`${id}`], 10);
      } catch (ex) {
        return 0;
      }
    },
    showComment() {
      this.commentsDisplay = !this.commentsDisplay;
    },
    openPopover(id, name, parentId, perms, event) {
      bus.$emit('taskPopMenu', id, name, parentId, perms, event);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .task-title {
    font-size: 1rem;
    display: flex;
    align-items: flex-start;
  }

  .task-expand {
    display: flex;
    align-items: center;
    text-align: center;
    width: 1.4rem;
    font-size: 1rem;
    height: 1.4rem;
    line-height: 1.4rem;
  }

  .fuzhu-img {
    padding: 0.1rem 0.5rem 0.1rem 0rem;
    width: 1.2rem;
    height: 1.2rem;
  }

  @mixin expand-icon($color) {
    color: $color;
  }

  .expand-icon-node1 {
    @include expand-icon(#6AA71B);
  }

  .expand-icon-node2 {
    @include expand-icon(#EC6941);
  }

  .expand-icon-node3 {
    @include expand-icon(#00B7EE);
  }

  .expand-icon-node4 {
    @include expand-icon(#F8B551);
  }

  .expand-icon-node5 {
    @include expand-icon(#B5B5B5);
  }

  .project-date {
    font-size: 0.8rem;
    display: flex;
    align-items:Center;
    padding-left: 1.35rem;
    padding-right: 0.5rem;
    color: $second-font-color;
  }

  @mixin project-status($color) {
    padding: 0rem 0.05rem;
    border: 0.08rem solid $color;
    border-radius: 0.3rem;
    width: 2.5rem;
    min-width: 2.5rem;
    height: 1rem;
    line-height: 1rem;
    text-align: center;
    font-size: 0.7rem;
    font-weight: 500;
    color: $color;
  }

  .project-status-assign {
    @include project-status(#f7ad3a);
  }

  .project-status-releasing {
    @include project-status(#8957a1);
  }

  .project-status-assigned {
    @include project-status(#008be6);
  }

  .project-status-working {
    @include project-status(#bb9e76);
  }
  .project-status-checking {
    @include project-status(#cf5152);
  }

  .project-status-checked {
    @include project-status(#5fad2f);
  }

  .sub-info {
    padding-top: 0.3rem;
    font-size: 0.8rem;
    color: $second-font-color;
  }

  .primary-text {
    padding-left: 0.2rem;
    color: $second-color;
  }

  .other-status-info {
    display: flex;
    justify-content: space-between;
  }

  .project-footer-row {
    padding-top: 0.5rem;
    padding-right: 1.85rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: $font-color;
  }

  .footer-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .project-msg-icon {
    color: $theme-color;
  }

  .point-badge {
    line-height: 8px;
    height: 8px;
    border-radius: 8px;
    padding: 0 0px;
    min-width: 8px;
    font-size: 8px;
    margin-left: -8px;
  }

  .icon-comments {
    color: $theme-color;
  }

  .swiper-info {
    text-align: center;
    padding: 0.5rem 0rem;
    background-color: #535353;
    font-size: 0.8rem;
  }

  .swiper-slide-info {
    color: $white-color;
  }

  .comments-expand-icon {
    text-align: right;
    padding-right: 4rem;
    color: #535353;
    margin-top: -0.5rem;
    margin-bottom: -0.2rem;
    line-height: 0.8rem;
  }

  .more-menu {
    padding-left: 0.5rem;
    padding-right: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/HierarchicalTask.vue